<div (click)="onToggle()" class="box-head">
  <a class="btn btn-link collapse-btn">
    {{ title }}
    <i *ngIf="isExpanded" class="fal fa-minus"></i>
    <i *ngIf="!isExpanded" class="fal fa-plus"></i>
  </a>
  <a
    *ngIf="editable && !(1 | isReadonlyRole)"
    (click)="$event.stopPropagation(); edit.emit()"
    [matTooltip]="tooltipText"
    matTooltipPosition="above"
    matTooltipClass="text-center"
    class="edit-btn"
  >
    <i class="fal fa-edit"></i>
  </a>
  <a
    *ngIf="editable && inquiry?.abbPrice && inquiry?.abbPrice.base && !(1 | isReadonlyRole)"
    (click)="$event.stopPropagation(); abbEdit.emit(inquiry)"
    matTooltip="View Airbnb charge breakdown"
    matTooltipPosition="above"
    matTooltipClass="text-center"
    class="edit-btn"
  >
    <i class="fal fa-server"></i>
  </a>
</div>
<div [@expanded]="expanded" [class.collapsed]="!isExpanded" class="box-body collapse show">
  <ng-container *ngIf="external || !inquiry?.bookingEngine">
    <div class="box-details">
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Charge</div>
        <div class="col-8">
          <span [innerHtml]="charges?.charge || 0 | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Additional Guests Fee</div>
        <div class="col-8">
          <span [innerHtml]="charges?.extraGuests || 0 | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Discount</div>
        <div class="col-8">
          <span [innerHtml]="charges?.discountSum || 0 | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Fees</div>
        <div class="col-8">
          <span [innerHtml]="charges?.feeSum || 0 | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Tax</div>
        <div class="col-8">
          <span [innerHtml]="charges?.taxFee | tokeetCurrency: currencySymbol"></span
          ><span>({{ inquiry?.bookingEngine?.taxPercent | number: '1.2-2' }}%)</span>
        </div>
      </div>
      <ng-container *ngIf="tryToGetFormulaCost | call: inquiryService:inquiry | async as formulaCost">
        <div class="box-dsc-row row">
          <div class="col-4 text-gray col-long">Booking Formula</div>
          <div class="col-8">
            <h4 [matTooltip]="currencyCode" matTooltipClass="text-center" matTooltipPosition="left" class="total-price">
              <span [innerHtml]="formulaCost | tokeetCurrency: currencySymbol"></span>
            </h4>
          </div>
        </div>
      </ng-container>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Total</div>
        <div class="col-8">
          <h4 [matTooltip]="currencyCode" matTooltipClass="text-center" matTooltipPosition="left" class="total-price">
            <span [innerHtml]="charges?.sum | tokeetCurrency: currencySymbol"></span>
          </h4>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!external && !!inquiry?.bookingEngine">
    <div class="box-details">
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Base Charge</div>
        <div class="col-8">
          <span [innerHtml]="inquiry?.bookingEngine?.extraBedroomsBase | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Additional Guests Fee</div>
        <div class="col-8">
          <span [innerHtml]="inquiry?.bookingEngine?.extraGuests | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row" *ngIf="!!inquiry?.bookingEngine?.extraBedrooms">
        <div class="col-4 text-gray">Additional Bedrooms Fee</div>
        <div class="col-8">
          <span [innerHtml]="inquiry?.bookingEngine?.extraBedrooms | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Discounts & Fees</div>
        <div class="col-8">
          <span [innerHtml]="inquiry?.bookingEngine?.discountTotal | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div *ngFor="let fee of inquiry?.bookingEngine?.bookingFees" class="box-dsc-row row">
        <div class="col-4 text-gray">
          {{ fee.name }}
        </div>
        <div class="col-8">
          <span [innerHtml]="fee.amount | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Taxes</div>
        <div class="col-8">
          <span [innerHtml]="inquiry?.bookingEngine?.taxTotal | tokeetCurrency: currencySymbol"></span>
        </div>
      </div>
      <ng-container *ngIf="tryToGetFormulaCost | call: inquiryService:inquiry | async as formulaCost">
        <div class="box-dsc-row row">
          <div class="col-4 text-gray col-long">Booking Formula</div>
          <div class="col-8">
            <h4 [matTooltip]="currencyCode" matTooltipClass="text-center" matTooltipPosition="left" class="total-price">
              <span [innerHtml]="formulaCost | tokeetCurrency: currencySymbol"></span>
            </h4>
          </div>
        </div>
      </ng-container>
      <div class="box-dsc-row row">
        <div class="col-4 text-gray">Total</div>
        <div class="col-8">
          <strong [innerHtml]="inquiry?.bookingEngine?.total | tokeetCurrency: currencySymbol"></strong>
        </div>
      </div>
    </div>
  </ng-container>
</div>
